
import { useEffect, useState } from 'react';

export default function Hero() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative h-[90vh] flex items-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/374177f14794f263afed867a638d6e41.jpg"
          alt="سماعتي - خدمات السمع المنزلية"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-l from-[#184187]/85 via-[#184187]/60 to-black/40"></div>
      </div>

      <div className="relative z-10 container mx-auto px-4 w-full" style={{ maxWidth: '1140px' }}>
        <div className="max-w-2xl mr-0 ml-auto text-right">
          <h1
            className={`text-5xl md:text-7xl font-bold text-white mb-6 transition-all duration-1000 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
            style={{ lineHeight: '1.3' }}
          >
            العناية الخاصة بسماعتك وسمعك أصبحت مسؤوليتنا
          </h1>
          <p
            className={`text-lg md:text-2xl text-white/90 mb-10 transition-all duration-1000 delay-200 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
            style={{ lineHeight: '1.8' }}
          >
            حلول مبتكرة لتحسين سمعك — مباشرة في منزلك أو مكان عملك، مع فريق من الأخصائيين السعوديين المؤهلين
          </p>
          <div
            className={`flex flex-col sm:flex-row gap-4 transition-all duration-1000 delay-400 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
          >
            <button
              onClick={scrollToContact}
              className="bg-[#184187] text-white px-8 py-4 rounded-lg text-lg font-medium hover:bg-[#0f2d6b] transition-all hover:scale-105 whitespace-nowrap cursor-pointer shadow-lg"
            >
              احجز موعدك الآن
            </button>
            <button
              onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-white/20 backdrop-blur-sm text-white border border-white/40 px-8 py-4 rounded-lg text-lg font-medium hover:bg-white/30 transition-all whitespace-nowrap cursor-pointer"
            >
              تعرف على خدماتنا
            </button>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-white/70"></i>
      </div>
    </section>
  );
}
